import React from 'react'
import { Link } from 'react-router-dom'
import { Calendar, ClipboardList } from 'lucide-react'
import { Card, CardBody } from '@/components/ui/Card'
import { ResponsiveCardGrid } from '@/components/layout/ResponsiveCardGrid'
import PlanStatusBadge from './PlanStatusBadge'
import { Plan } from '@/types/plan'
import { formatPlanDate } from '@/utils/date'

interface PlanListProps {
  plans: Plan[]
}

const PlanList: React.FC<PlanListProps> = ({ plans }) => {
  if (plans.length === 0) {
    return (
      <div className="text-center py-8">
        <ClipboardList className="w-12 h-12 mx-auto text-gray-400 mb-3" />
        <p className="text-gray-600">No plans yet.</p>
      </div>
    )
  }

  return (
    <ResponsiveCardGrid>
      {plans.map((plan) => (
        <Link key={plan.id} to={`/plans/${plan.id}`} className="block h-full">
          <Card className="flex h-full flex-col hover:shadow-md transition-shadow">
            <CardBody className="flex h-full flex-col">
              <div className="flex items-center justify-between">
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="text-lg font-semibold text-gray-900">{plan.title}</h3>
                    <PlanStatusBadge status={plan.status} />
                  </div>
                </div>
                <div className="text-sm text-gray-500">{plan.progressPercentage}%</div>
              </div>
              <div className="mt-auto flex items-center gap-1 pt-3 text-sm text-gray-500">
                <Calendar className="w-4 h-4" />
                <span>
                  {formatPlanDate(plan.startDate)} – {formatPlanDate(plan.endDate)}
                </span>
              </div>
            </CardBody>
          </Card>
        </Link>
      ))}
    </ResponsiveCardGrid>
  )
}

export default PlanList
